module.exports = __webpack_public_path__ + "img/ico.2215bbec.svg";